// The ONE normalisation for matching Meta answers and form names — a leaf, so
// compose.ts (the dispatcher) and each provider module can both use it without
// importing each other.

/** trim + collapse whitespace + lowercase. */
export function normalizeKey(value: string | null | undefined): string {
  return (value ?? '').trim().replace(/\s+/g, ' ').toLowerCase();
}
